import { render, staticRenderFns } from "./AffiliateEditCpa.vue?vue&type=template&id=a4c9b1b6&scoped=true&"
import script from "./AffiliateEditCpa.vue?vue&type=script&lang=js&"
export * from "./AffiliateEditCpa.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateEditCpa.vue?vue&type=style&index=0&id=a4c9b1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9b1b6",
  null
  
)

export default component.exports